import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'
import Layout from '../../components/Layout'
import Spinner from '../../components/Spinner'
import { listUsers } from '../../api/users'
import { useAuth } from '../../context/AuthContext'
import { useT } from '../../i18n'

export default function UsersPage() {
  const { user } = useAuth()
  const lang = user?.language ?? 'ru'
  const tr = useT(lang)
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const { data: users, isLoading } = useQuery({
    queryKey: ['users', search],
    queryFn: () => listUsers({ role: 'client', search: search || undefined, limit: 100 }),
    placeholderData: (prev) => prev,
  })

  return (
    <Layout title={tr('clients')}>
      <div className="relative mb-4">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-tg-hint" />
        <input
          className="input pl-9"
          placeholder={tr('search')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {isLoading ? (
        <Spinner className="mt-10" />
      ) : !users?.length ? (
        <p className="text-center text-tg-hint mt-10">{tr('noClients')}</p>
      ) : (
        <div className="flex flex-col gap-2">
          {users.map((u) => (
            <button
              key={u.id}
              onClick={() => navigate(`/admin/users/${u.id}`)}
              className="card w-full text-left flex items-center gap-3 active:opacity-70"
            >
              <div className="w-10 h-10 rounded-full bg-tg-hint/20 flex items-center justify-center flex-shrink-0 text-lg font-semibold text-tg-hint">
                {u.full_name[0]}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-tg-text text-sm">{u.full_name}</p>
                <p className="text-xs text-tg-hint">{u.phone}</p>
              </div>
              <div className="flex flex-col items-end gap-1">
                {!u.is_active && (
                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: 'rgba(217,119,87,0.10)', color: '#D97757' }}>Блок</span>
                )}
                {u.is_verified && (
                  <span style={{ fontSize: 11, color: '#6FB89A' }}>✓</span>
                )}
                {u.personal_discount > 0 && (
                  <span style={{ fontSize: 11, color: '#F97316' }}>-{u.personal_discount}%</span>
                )}
              </div>
            </button>
          ))}
        </div>
      )}
    </Layout>
  )
}
